<template>
  <div class="">
    <agency-contacts-create> </agency-contacts-create>
  </div>
</template>

<script>
import AgencyContactsCreate from "@/components/wallet/agency-contacts/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    AgencyContactsCreate,
  },
  created() {
    this.notifyQueue({
      text: "Crea Contatto",
      path: "agency_contacts.create0",
      level: 4,
    });
  },
};
</script>
